var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Err c-text-c"},[_vm._m(0),_vm._m(1),_c('h5',{staticClass:"o-mt c-color-f"},[_vm._v("抱歉，当前页面不存在")]),_c('Button',{staticClass:"o-mt-h",attrs:{"type":"default"},on:{"click":function($event){return _vm.Rd('index')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"c-color-f"},[_c('b',[_vm._v("404")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"name"},[_c('b',[_vm._v("THIS PAGE NOT FOUND !")])])
}]

export { render, staticRenderFns }